import { render, staticRenderFns } from "./CustomerEditButton.vue?vue&type=template&id=09f9ad22&scoped=true&"
import script from "./CustomerEditButton.vue?vue&type=script&lang=ts&"
export * from "./CustomerEditButton.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerEditButton.vue?vue&type=style&index=0&id=09f9ad22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f9ad22",
  null
  
)

export default component.exports